export default {
    listagem: {
        titulo_pagina: 'Scale List',
        novo: 'Create New Scale',
        habilitado: 'Able',
        desabilitado: 'Disabled',
        table: {
            empty: 'No Scale Found',
            nome: 'Name',
            codigo: 'Code',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Scale',
            editar: 'Edit Scale'
        },
        fields: {
            codigo: {
                label: 'Code',
                description: 'Scale Code'
            },
            nome: {
                label: 'Name',
                description: 'Scale Name'
            },
            status: {
                label: 'Status',
                description: 'Scale active or inactive status'
            },
            botao_salvar : 'Save Scale'
        },
        create: {
            success: 'Scale created successfully!',
            error: 'Error creating scale!'
        },
        update: {
            success: 'Scale successfully edited!',
            error: 'Error editing scale!'
        }
    }
}
